import React from 'react';
import BackButton from './BackButton';
import styles from '../styles/PageHeader.module.css';

/**
 * PageHeader — the one top bar for every screen that is not the main
 * chat/circles surface (those keep the brand Header with the wordmark and
 * mode nav; everything else shares this).
 *
 * The audit found seven competing header patterns (UX-12): gradient vs white
 * vs translucent surfaces, titles left / centered / below-the-back-link, and
 * the back control in three placements. This collapses them to one:
 *
 *   dark --color-primary bar · BackButton onDark · white serif title inline ·
 *   optional subtitle · optional right-side actions slot
 *
 * Deliberately SOLID primary, not the old primary→sage gradient: white text
 * over the sage end of that gradient is 3.57:1 (axe never flagged it only
 * because it cannot compute gradient backdrops). On solid primary the title
 * is 10:1 and the muted-inverse subtitle 6.8:1.
 *
 * Props:
 * - title (required)
 * - subtitle: small line under the title (e.g. "2 beads earned")
 * - onBack: shows the BackButton when provided
 * - backLabel: destination name for the aria-label ("Chat" → "Back to Chat")
 * - actions: right-aligned node (kept small — an icon button or a text link)
 */
function PageHeader({ title, subtitle, onBack, backLabel, actions }) {
  return (
    <header className={styles.header}>
      {onBack && (
        <BackButton onClick={onBack} label={backLabel} variant="onDark" className={styles.back} />
      )}
      <div className={styles.titles}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </header>
  );
}

export default PageHeader;
